import { createContext } from 'react';

import { ServiceItem } from '@totem/components/context/services/types';

interface Context {
  services: ServiceItem[];
  loading: boolean;
}

export default createContext<Context>({
  services: [],
  loading: false,
});
